export type AlertType =
  | 'swa_filed'
  | 'safety_event'
  | 'high_sse'
  | 'missing_dsr'
  | 'overdue_action_item';

export type AlertSeverity = 'critical' | 'high' | 'medium' | 'low';

export interface Alert {
  id: string;
  tenant_id: string;
  project_id: string;
  alert_type: AlertType;
  severity: AlertSeverity;
  message: string;
  source_dsr_id: string | null;
  source_record_id: string | null;
  metadata: Record<string, unknown>;
  dedup_date: string;
  acknowledged_at: string | null;
  acknowledged_by: string | null;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  is_deleted: boolean;
}

export const ALERT_TYPE_LABEL: Record<AlertType, string> = {
  swa_filed: 'Stop Work Authority',
  safety_event: 'Safety Event',
  high_sse: 'High SSE %',
  missing_dsr: 'Missing DSR',
  overdue_action_item: 'Overdue Action Items',
};

export const SEVERITY_RANK: Record<AlertSeverity, number> = {
  critical: 4,
  high: 3,
  medium: 2,
  low: 1,
};
